module.exports = __webpack_public_path__ + "static/media/DSCF2560.eb7b59f0.jpg";